import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import * as vivus from 'vivus';
import { UntypedFormControl } from '@angular/forms';

import {
  computePerspectiveTransform,
  PerspectivePoint,
} from './perspective-transform';

@Component({
  selector: 'app-picker',
  templateUrl: './picker.component.html',
  styleUrls: ['./picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PickerComponent implements OnInit {
  dst: PerspectivePoint[] = [];
  url = new UntypedFormControl(
    'http://dev.zalamo.com:5555/public-image?fileName=public/cku2ylncx0001389bepw90q52&organizationId=zalamo&size=1920',
  );

  constructor() {}

  ngOnInit(): void {
    const svg = document.querySelector('svg');
    console.log(svg);
    new vivus(svg, { duration: 2000 });
  }

  makePoint(evt: PointerEvent) {
    console.log('clicked');
    if (!(evt.target instanceof Element)) return;
    const box = evt.target.getBoundingClientRect();
    const point: PerspectivePoint = [
      evt.clientX - box.left,
      evt.clientY - box.top,
    ];
    this.dst.push(point);

    if (this.dst.length === 4) {
      console.log(this.dst);
      console.log(
        JSON.stringify(this.dst.map(([x, y]) => [x / 1920, y / 1080])),
      );
      const img = document.getElementById('img') as HTMLImageElement;
      const w = 666;
      const h = 1000;
      const transform = computePerspectiveTransform(
        [
          [0, 0],
          [w, 0],
          [w, h],
          [0, h],
        ],
        this.dst,
      );
      document.getElementById('photo').style.visibility = 'visible';
      document.getElementById('transform').style.transformOrigin = '0 0';
      document.getElementById('transform').style.transform = transform;
    }
  }
}
